import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../components/HomePage.vue')
  },
  {
    path: '/services',
    component: () => import('../components/ServicesPage.vue')
  },
  {
    path: '/gallery',
    component: () => import('../components/GalleryPage.vue')
  },
  {
    path: '/contact',
    component: () => import('../components/ContactPage.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  linkExactActiveClass: 'active-link'
})

export default router